export var paletteTokens = {
  brand: {
    '50': function _(_ref) {
      var token = _ref.token;
      return token('palette.indigo.50');
    },
    '100': function _(_ref2) {
      var token = _ref2.token;
      return token('palette.indigo.100');
    },
    '200': function _(_ref3) {
      var token = _ref3.token;
      return token('palette.indigo.200');
    },
    '300': function _(_ref4) {
      var token = _ref4.token;
      return token('palette.indigo.300');
    },
    '400': function _(_ref5) {
      var token = _ref5.token;
      return token('palette.indigo.400');
    },
    '500': function _(_ref6) {
      var token = _ref6.token;
      return token('palette.indigo.500');
    },
    '600': function _(_ref7) {
      var token = _ref7.token;
      return token('palette.indigo.600');
    },
    '700': function _(_ref8) {
      var token = _ref8.token;
      return token('palette.indigo.700');
    },
    '800': function _(_ref9) {
      var token = _ref9.token;
      return token('palette.indigo.800');
    },
    '900': function _(_ref10) {
      var token = _ref10.token;
      return token('palette.indigo.900');
    }
  },
  white: 'hsl(0,0%,100%)',
  black: 'hsl(0,0%,0%)',
  grey: {
    '50': 'hsl(0,0%,98%)',
    '100': 'hsl(0,0%,96%)',
    '200': 'hsl(0,0%,95%)',
    '300': 'hsl(210,4%,91%)',
    '400': 'hsl(220,4%,86%)',
    '500': 'hsl(220,3%,80%)',
    '600': 'hsl(214,3%,59%)',
    '700': 'hsl(220,4%,46%)',
    '800': 'hsl(210,5%,33%)',
    '900': 'hsl(214,13%,21%)'
  },
  slate: {
    '50': 'hsl(240,27%,98%)',
    '100': 'hsl(252,29%,97%)',
    '200': 'hsl(240,20%,92%)',
    '300': 'hsl(240,15%,87%)',
    '400': 'hsl(243,14%,73%)',
    '500': 'hsl(243,11%,58%)',
    '600': 'hsl(248,13%,42%)',
    '700': 'hsl(249,15%,33%)',
    '800': 'hsl(249,20%,25%)',
    '900': 'hsl(249,35%,15%)'
  },
  neutral: {
    '50': 'hsl(60,25%,98%)',
    '100': 'hsl(36,29%,97%)',
    '200': 'hsl(40,32%,93%)',
    '300': 'hsl(41,28%,89%)',
    '400': 'hsl(39,32%,86%)',
    '500': 'hsl(39,25%,77%)',
    '600': 'hsl(39,24%,70%)',
    '700': 'hsl(38,22%,63%)',
    '800': 'hsl(40,21%,54%)',
    '900': 'hsl(40,21%,43%)'
  },
  red: {
    '50': 'hsl(0,100%,98%)',
    '100': 'hsl(0,89%,96%)',
    '200': 'hsl(0,88%,93%)',
    '300': 'hsl(0,92%,90%)',
    '400': 'hsl(0,87%,82%)',
    '500': 'hsl(0,91%,74%)',
    '600': 'hsl(0,86%,67%)',
    '700': 'hsl(0,82%,59%)',
    '800': 'hsl(0,74%,50%)',
    '900': 'hsl(0,81%,41%)'
  },
  orange: {
    '50': 'hsl(24,100%,98%)',
    '100': 'hsl(25,90%,96%)',
    '200': 'hsl(23,94%,93%)',
    '300': 'hsl(23,94%,87%)',
    '400': 'hsl(23,94%,81%)',
    '500': 'hsl(23,94%,75%)',
    '600': 'hsl(23,85%,66%)',
    '700': 'hsl(23,79%,58%)',
    '800': 'hsl(23,77%,52%)',
    '900': 'hsl(23,86%,41%)'
  },
  yellow: {
    '50': 'hsl(47,82%,98%)',
    '100': 'hsl(43,90%,96%)',
    '200': 'hsl(43,89%,93%)',
    '300': 'hsl(43,88%,90%)',
    '400': 'hsl(43,87%,82%)',
    '500': 'hsl(43,93%,74%)',
    '600': 'hsl(43,90%,62%)',
    '700': 'hsl(43,88%,49%)',
    '800': 'hsl(43,100%,42%)',
    '900': 'hsl(43,97%,38%)'
  },
  green: {
    '50': 'hsl(144,45%,98%)',
    '100': 'hsl(144,50%,96%)',
    '200': 'hsl(147,50%,93%)',
    '300': 'hsl(148,45%,84%)',
    '400': 'hsl(148,45%,75%)',
    '500': 'hsl(148,47%,65%)',
    '600': 'hsl(147,48%,56%)',
    '700': 'hsl(148,58%,44%)',
    '800': 'hsl(148,56%,38%)',
    '900': 'hsl(148,60%,32%)'
  },
  teal: {
    '50': 'hsl(180,40%,98%)',
    '100': 'hsl(180,43%,96%)',
    '200': 'hsl(184,44%,93%)',
    '300': 'hsl(183,47%,85%)',
    '400': 'hsl(183,45%,75%)',
    '500': 'hsl(184,53%,64%)',
    '600': 'hsl(184,66%,47%)',
    '700': 'hsl(184,82%,39%)',
    '800': 'hsl(184,93%,32%)',
    '900': 'hsl(184,100%,27%)'
  },
  blue: {
    '50': 'hsl(203,80%,98%)',
    '100': 'hsl(199,80%,96%)',
    '200': 'hsl(199,78%,93%)',
    '300': 'hsl(200,77%,86%)',
    '400': 'hsl(200,83%,80%)',
    '500': 'hsl(200,85%,74%)',
    '600': 'hsl(200,86%,60%)',
    '700': 'hsl(200,91%,49%)',
    '800': 'hsl(200,96%,44%)',
    '900': 'hsl(200,100%,38%)'
  },
  indigo: {
    '50': 'hsl(220,82%,98%)',
    '100': 'hsl(224,85%,95%)',
    '200': 'hsl(223,91%,91%)',
    '300': 'hsl(222,81%,86%)',
    '400': 'hsl(223,74%,76%)',
    '500': 'hsl(223,63%,65%)',
    '600': 'hsl(223,47%,51%)',
    '700': 'hsl(221,47%,41%)',
    '800': 'hsl(220,57%,32%)',
    '900': 'hsl(220,74%,23%)'
  },
  magenta: {
    '50': 'hsl(330,40%,98%)',
    '100': 'hsl(327,43%,96%)',
    '200': 'hsl(330,44%,93%)',
    '300': 'hsl(332,43%,86%)',
    '400': 'hsl(331,43%,79%)',
    '500': 'hsl(330,47%,70%)',
    '600': 'hsl(330,57%,65%)',
    '700': 'hsl(331,55%,58%)',
    '800': 'hsl(330,57%,48%)',
    '900': 'hsl(332,60%,42%)'
  },
  tint: {
    light: {
      '50': 'hsla(0,0%,100%,0.05)',
      '100': 'hsla(0,0%,100%,0.1)',
      '200': 'hsla(0,0%,100%,0.2)',
      '300': 'hsla(0,0%,100%,0.3)',
      '400': 'hsla(0,0%,100%,0.4)',
      '500': 'hsla(0,0%,100%,0.5)',
      '600': 'hsla(0,0%,100%,0.6)',
      '700': 'hsla(0,0%,100%,0.7)',
      '800': 'hsla(0,0%,100%,0.8)',
      '900': 'hsla(0,0%,100%,0.9)'
    }
  },
  shade: {
    dark: {
      '50': 'hsla(0,0%,0%,0.05)',
      '100': 'hsla(0,0%,0%,0.1)',
      '200': 'hsla(0,0%,0%,0.2)',
      '300': 'hsla(0,0%,0%,0.3)',
      '400': 'hsla(0,0%,0%,0.4)',
      '500': 'hsla(0,0%,0%,0.5)',
      '600': 'hsla(0,0%,0%,0.6)',
      '700': 'hsla(0,0%,0%,0.7)',
      '800': 'hsla(0,0%,0%,0.8)',
      '900': 'hsla(0,0%,0%,0.9)'
    },
    primary: {
      '50': 'hsla(220,74%,23%,0.05)',
      '100': 'hsla(220,74%,23%,0.1)',
      '200': 'hsla(220,74%,23%,0.2)',
      '300': 'hsla(220,74%,23%,0.3)',
      '400': 'hsla(220,74%,23%,0.4)',
      '500': 'hsla(220,74%,23%,0.5)',
      '600': 'hsla(220,74%,23%,0.6)',
      '700': 'hsla(220,74%,23%,0.7)',
      '800': 'hsla(220,74%,23%,0.8)',
      '900': 'hsla(220,74%,23%,0.9)'
    }
  }
};